// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"N0-z","sponsoredTooltipWrapper":"O0-z","sponsoredTooltip":"P0-z","newCard":"Q0-z"};